<div class="container my-3">
  <div class="row banner rounded">
    <ng-content></ng-content>
  </div>
</div>
